/*
 * 
 */
(function($){
	var shareHTML = "<div class='share_this_container' id='share_this_container'>" +
							"</div>";
	var shareInnerHTML = 		"<span class='share_link'></span>" +
								"<span class='share_link'></span>" +
								"<span class='share_link'></span>" +
								"<span class='share_link'></span>" +
								"<span class='share_link'></span>";
    jQuery(document).ready(function($) {
			var share = $(shareHTML);
			$('body').append(share);
			share.hide();
    	$('.button_share a').on('click', function(event) {
    		event.preventDefault();
    		/* Act on the event */
    		M1.Lightbox.hide();
    		var share_this_container = $('#share_this_container');
    		share_this_container.html(shareInnerHTML);
    		share_this_container.show();
    		var context = $(this);
    		var permalink = context.attr('href');
    		var course_info = context.closest('.recommended_container').data('course');
			M1.Lightbox.displayLightboxBackground();
			$.each(['facebook', 'twitter', 'linkedin', 'pinterest', 'email'], function(index, el) {
				stWidget.addEntry({
								"service": el,
								"element": $('.share_link:nth-of-type('+ (index + 1) +')')[0],
								"url":permalink,
								"title":course_info.title,
								"type":"large",
								"text":"ShareThis" ,
								"image":course_info.pic,
								"summary": course_info.description   
							});	
			});
			M1.util.centerElement(share_this_container);
			
    	});
    });
})(jQuery);